import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { WfsDuplicateOrderResponse } from "../../../types/Wfs/WfsResponse";
import { useNavigate } from "react-router-dom";
import { useDataSelectionContext } from "../DataSelectionContext";
import { useApiContext } from "../../api/ApiContext";

export interface DuplicateOrderViewProps {
  duplicateOrder: WfsDuplicateOrderResponse;
}

const DuplicateOrderView = ({
  duplicateOrder: { orderId, orderItemId, isInBasket },
}: DuplicateOrderViewProps) => {
  const navigate = useNavigate();
  const { loading } = useDataSelectionContext();
  const { abort } = useApiContext();

  const cancel = () => {
    if (loading) abort();
    navigate("/");
  };

  return (
    <>
      <Modal.Body>
        <Alert variant="warning">Duplicate order detected</Alert>

        {isInBasket && (
          <p>
            An order with the same parameters is already in your basket. Please
            review your basket, or contact{" "}
            <a
              href="https://support.basemap.co.uk/support/login"
              target="_blank"
              rel="noreferrer">
              support
            </a>{" "}
            for help.
          </p>
        )}
        {!isInBasket && (
          <p>
            An order with the same parameters was placed within the last 24
            hours. Please review your orders, or contact{" "}
            <a
              href="https://support.basemap.co.uk/support/login"
              target="_blank"
              rel="noreferrer">
              support
            </a>{" "}
            for help.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        {isInBasket && (
          <Button
            variant="success"
            onClick={() => navigate("/basket")}
            disabled={loading}>
            View Basket {loading && <Spinner size="sm" />}
          </Button>
        )}
        {!isInBasket && (
          <Button
            variant="success"
            onClick={() => navigate("/my-orders")}
            disabled={loading}>
            View My Orders {loading && <Spinner size="sm" />}
          </Button>
        )}

        <Button variant="danger" onClick={cancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DuplicateOrderView;
